
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("6pKAO", function(module, exports) {

$parcel$export(module.exports, "People", () => $366c58be1cf242b2$export$8d3edc4d62e152ad);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $jG2Eu = parcelRequire("jG2Eu");

var $d2wNG = parcelRequire("d2wNG");

var $cTgSO = parcelRequire("cTgSO");

var $7ZwLV = parcelRequire("7ZwLV");
var $enb7h = parcelRequire("enb7h");

var $aZaPn = parcelRequire("aZaPn");

var $1zdJL = parcelRequire("1zdJL");

var $gevkZ = parcelRequire("gevkZ");

var $7ZZxN = parcelRequire("7ZZxN");

var $1Iui1 = parcelRequire("1Iui1");

var $6j4bv = parcelRequire("6j4bv");

var $3q7Yq = parcelRequire("3q7Yq");

var $0cdA8 = parcelRequire("0cdA8");

var $2NgrR = parcelRequire("2NgrR");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");

var $k8Qyf = parcelRequire("k8Qyf");

var $3Y2Y8 = parcelRequire("3Y2Y8");

var $Gz4Lz = parcelRequire("Gz4Lz");

var $82rJa = parcelRequire("82rJa");

var $iFLJg = parcelRequire("iFLJg");

var $7vTKl = parcelRequire("7vTKl");
var $3BTZc = parcelRequire("3BTZc");

var $2futN = parcelRequire("2futN");


var $hFK9U = parcelRequire("hFK9U");

var $10fdS = parcelRequire("10fdS");

var $cWiVr = parcelRequire("cWiVr");

var $kJlBc = parcelRequire("kJlBc");

var $jD3pk = parcelRequire("jD3pk");

var $6WXNs = parcelRequire("6WXNs");

var $hb3Di = parcelRequire("hb3Di");
var $105cx = parcelRequire("105cx");

var $3K78m = parcelRequire("3K78m");

var $8ZFO4 = parcelRequire("8ZFO4");

var $21Sgb = parcelRequire("21Sgb");
var $6yplV = parcelRequire("6yplV");
var $gd0Sp = parcelRequire("gd0Sp");

var $bB06Z = parcelRequire("bB06Z");

var $5kDtB = parcelRequire("5kDtB");

var $grCEQ = parcelRequire("grCEQ");

var $olGf9 = parcelRequire("olGf9");

var $5ZWbT = parcelRequire("5ZWbT");

var $iRTpS = parcelRequire("iRTpS");

var $69xWj = parcelRequire("69xWj");

var $gvn5f = parcelRequire("gvn5f");

var $eXtUa = parcelRequire("eXtUa");

var $5Jczu = parcelRequire("5Jczu");

var $d5ydC = parcelRequire("d5ydC");
const $366c58be1cf242b2$var$PeopleMenuForRenotifyExperiment = (props)=>{
    const renotifyExperimentProps = (0, $2NgrR.useRenotifyInviteesExperimentForJSW)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bB06Z.default), {
        ...props,
        renotifyExperimentProps: renotifyExperimentProps
    });
};
const $366c58be1cf242b2$var$PeopleMenuSwitcher = (props)=>(0, $eI5EY.fg)('jsw_remind_admins_about_invited_users_feature_gate') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($366c58be1cf242b2$var$PeopleMenuForRenotifyExperiment, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bB06Z.default), props);
const $366c58be1cf242b2$var$getInviteThirdPartyTeamsExperiment = ()=>(0, $1ybV0.getMultivariateFeatureFlag)('confluence.frontend.growth.invite-3rd-party-teams', (0, $1Iui1.NOT_ENROLLED), [
        (0, $1Iui1.NOT_ENROLLED),
        (0, $1Iui1.CONTROL),
        (0, $1Iui1.VARIATION)
    ]);
const $366c58be1cf242b2$var$STORAGE_KEY = 'jwm.invite-business-teams-modal-viwed-timestamp';
const $366c58be1cf242b2$var$SITE_USER_TRAIT_HAS_VIEW_EXPERIMENT = 'jira_screen_viewed_invitebusinessteamsmodal_first';
const $366c58be1cf242b2$var$STORAGE_PROVIDER_KEY = 'jira_invite-business-teams-modal';
const $366c58be1cf242b2$export$c2ed3351cac403d1 = (0, $aZaPn.createLocalStorageProvider)($366c58be1cf242b2$var$STORAGE_PROVIDER_KEY);
const $366c58be1cf242b2$var$PeopleMenuDropdown = ()=>{
    const [inviteBusinessTeamsModalData, setInviteBusinessTeamsModalData] = (0, $eUqFw.useState)({
        isOpen: false,
        userCounts: 0
    });
    const [isMenuOpen, { off: closeMenu, on: openMenu }] = (0, $3BTZc.useTopMenus)((0, $7vTKl.MENU_ID).PEOPLE);
    const baseUrl = '';
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    const route = (0, $10fdS.useCurrentRoute)();
    const { push: push } = (0, $kJlBc.useRouterActions)();
    const isHighlighted = (0, $69xWj.useMenuHighlighted)((0, $7vTKl.MENU_ID).PEOPLE);
    const triggerAnalytics = (0, $gvn5f.useNavigationItemAnalytics)({
        navigationItemId: (0, $5kDtB.NAVIGATION_ITEM_ID).PEOPLE
    });
    const [isEventFromSpotlightTour] = (0, $iRTpS.useFromSpotlightTour)('spotlight');
    const checkUsersGroupPermission = (0, $eXtUa.useBrowseUsersGroupsPermissions)();
    const addFlag = (0, $eUqFw.useCallback)(// @ts-expect-error - TS7031 - Binding element 'appearance' implicitly has an 'any' type.
    ({ appearance: appearance, ...flagProps })=>{
        if (appearance === 'success' || appearance === 'normal') // @ts-expect-error Type error after Flag props have been fixed globally, to be fixed by owning team
        showFlag((serviceProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $Gz4Lz.default), {
                ...flagProps,
                ...serviceProps
            }));
        if (appearance === 'warning') // @ts-expect-error Type error after Flag props have been fixed globally, to be fixed by owning team
        showFlag((serviceProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $82rJa.default), {
                ...flagProps,
                ...serviceProps
            }));
        if (appearance === 'error') // @ts-expect-error Type error after Flag props have been fixed globally, to be fixed by owning team
        showFlag((serviceProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3Y2Y8.default), {
                ...flagProps,
                ...serviceProps
            }));
    }, [
        showFlag
    ]);
    // @ts-expect-error - TS7006 - Parameter 'url' implicitly has an 'any' type.
    const pushRoute = (0, $eUqFw.useCallback)((url)=>push(`${baseUrl}${url}`), [
        baseUrl,
        push
    ]);
    let peopleMenuWrapperRef;
    if ((0, $eI5EY.fg)('jwm_tailored_onboarding_invite_team_fix_gate')) // eslint-disable-next-line react-hooks/rules-of-hooks
    peopleMenuWrapperRef = (0, $105cx.useRegisterNudgeTarget)((0, $8379f5d78bf6fb5a$export$77bc79debbf5c069), true).ref;
    else // eslint-disable-next-line react-hooks/rules-of-hooks
    peopleMenuWrapperRef = (0, $eUqFw.useRef)(null);
    const { data: { user: user } } = (0, $cWiVr.useCurrentUser)();
    const projectTeamAccessData = (0, $5Jczu.useTPAExperiment)();
    const teamCreateDialogProps = (0, $eUqFw.useMemo)(()=>{
        const dialogProps = {
            currentUser: {
                id: user.accountId || '',
                fullName: user.userFullname,
                // @ts-expect-error - TS2339 - Property 'emailAddress' does not exist on type 'DataBasic | (DataBasic & ResponseSuccess)'. | TS2339 - Property 'emailAddress' does not exist on type 'DataBasic | (DataBasic & ResponseSuccess)'.
                email: user.emailAddress !== undefined ? user.emailAddress : '',
                // @ts-expect-error - TS2339 - Property 'avatarUrls' does not exist on type 'DataBasic | (DataBasic & ResponseSuccess)'. | TS2339 - Property 'avatarUrls' does not exist on type 'DataBasic | (DataBasic & ResponseSuccess)'.
                avatarUrl: user?.avatarUrls ? user.avatarUrls['16x16'] : '',
                nickname: user?.userFullname
            },
            enableMembershipSettingsChoice: true,
            projectTeamAccess: projectTeamAccessData
        };
        dialogProps.onClose = ()=>{
            if (peopleMenuWrapperRef?.current) requestAnimationFrame(()=>{
                peopleMenuWrapperRef?.current?.querySelector('button')?.focus();
            });
        };
        return dialogProps;
    // the peopleMenuWrapperRef doesn't change as the condition if FG is static
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        projectTeamAccessData,
        user
    ]);
    (0, $eUqFw.useEffect)(()=>{
        // close menu when transitioning to other pages.
        closeMenu();
        // close menu on unmount
        return closeMenu;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        route
    ]);
    const { data: projectSidebarNavigationData } = (0, $2futN.useProjectSidebarNavigation)();
    const subProduct = (0, $iFLJg.projectTypeToSubProduct)(projectSidebarNavigationData?.projectType);
    const { cloudId: cloudId, atlassianAccountId: atlassianAccountId, appEditions: { software: software } } = (0, $gd0Sp.useTenantContext)();
    const { data: orgId } = (0, $jD3pk.useOrgId)();
    const invitePeopleExperimentalFeatures = (0, $eUqFw.useMemo)(()=>({
            inviteThirdPartyTeams: $366c58be1cf242b2$var$getInviteThirdPartyTeamsExperiment(),
            displayInfiSpotlight: (0, $1ybV0.ff)('confluence.frontend.growth.display-infi-spotlight')
        }), []);
    const continueUrl = window.location.href;
    const entryPoint = (0, $6j4bv.useEntryPoint)((0, $1zdJL.inviteBusinessTeamsModalEntryPoint), {});
    const [{ traits: traits }] = (0, $gevkZ.usePersonalizationProvider)();
    const firstActivationDateMs = (0, $21Sgb.useFirstActivationDateMs)();
    const storedValue = $366c58be1cf242b2$export$c2ed3351cac403d1.get($366c58be1cf242b2$var$STORAGE_KEY);
    const isSoftwareProject = subProduct === (0, $7ZZxN.SOFTWARE_PROJECT);
    const isValidAppEdition = software === (0, $6WXNs.FREE_EDITION) || software === (0, $6WXNs.STANDARD_EDITION);
    const isValidSiteAge = firstActivationDateMs && (0, $d2wNG.default)(new Date(), firstActivationDateMs) > 28;
    const hasDismissedInviteBefore = storedValue || traits.some((trait)=>trait.name === $366c58be1cf242b2$var$SITE_USER_TRAIT_HAS_VIEW_EXPERIMENT);
    const showModal = Boolean(isSoftwareProject && isValidAppEdition && isValidSiteAge && !hasDismissedInviteBefore && (0, $1ybV0.ff)('jira.productionise-invite-business-team-after-inviting-users-to-jsw_9k2aw'));
    const { openModal: openModal } = (0, $enb7h.useInvitePeopleModal)({
        continueUrl: continueUrl,
        enableThirdParty: true,
        experimentalFeatures: invitePeopleExperimentalFeatures,
        orgId: orgId,
        resourceAri: `ari:cloud:jira::site/${cloudId}`,
        showFlag: addFlag,
        source: 'peopleMenu',
        subProduct: subProduct,
        experimental_applicationEdition: software,
        navigation: {
            directoryContextEntryPoint: '/jira'
        },
        onSubmit: async (data)=>{
            const { inviteUsersResponse: inviteUsersResponse } = await data.defaultOnSubmit();
            // Handle invite business team modal experiment
            if (showModal) {
                const invitedJswUsers = (0, $d5ydC.getInvitedJswUsers)(inviteUsersResponse);
                const invitedJswUserCount = invitedJswUsers.length;
                // make sure we only display our modal when invites are JSW
                if (invitedJswUserCount > 0) {
                    setInviteBusinessTeamsModalData({
                        isOpen: true,
                        userCounts: invitedJswUserCount
                    });
                    // Make sure user only see the dialog once, and avoid loading traits everytime when user invites a person
                    $366c58be1cf242b2$export$c2ed3351cac403d1.set($366c58be1cf242b2$var$STORAGE_KEY, String(new Date()));
                    entryPoint.entryPointActions.load();
                }
            }
        },
        // this is used to handle `add more people` button clicked, we need to hide invite business team modal
        ...showModal ? {
            experimental_onReopenHandler: ()=>{
                openModal();
                setInviteBusinessTeamsModalData({
                    isOpen: false,
                    userCounts: 0
                });
            }
        } : {}
    });
    const invitePeopleHandlers = (0, $eUqFw.useMemo)(()=>({
            handleClick: openModal
        }), [
        openModal
    ]);
    if (!atlassianAccountId) return null;
    const renderPeopleMenu = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($366c58be1cf242b2$var$PeopleMenuSwitcher, {
            shouldRenderToParent: true,
            product: "jira",
            cloudId: cloudId,
            userId: atlassianAccountId,
            isBrowseUsersEnabled: checkUsersGroupPermission,
            // allow PeopleMenu to do transitions to in-product People Directory
            pushRoute: pushRoute,
            isHighlighted: isHighlighted,
            // @ts-expect-error - TS2322 - Type '({ appearance, ...flagProps }: { [x: string]: any; appearance: any; }) => void' is not assignable to type '(flag: Flag) => void'.
            addFlag: addFlag,
            onClick: triggerAnalytics,
            // manage open state
            isOpen: isMenuOpen,
            onOpen: openMenu,
            onClose: isEventFromSpotlightTour ? (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))) : closeMenu,
            customChevronIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $olGf9.ChevronRightIcon), null),
            enablePreFetchingByHovering: false,
            subProduct: subProduct,
            isSSR: false,
            orgId: orgId ?? undefined,
            teamCreateDialogProps: teamCreateDialogProps,
            invitePeopleHandlers: invitePeopleHandlers,
            isSectionList: true
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: (0, $7vTKl.MENU_ID).PEOPLE,
        packageName: (0, $5kDtB.PACKAGE_NAME),
        fallback: "unmount",
        teamName: "navigation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($366c58be1cf242b2$export$5d16118c15d58d20, {
        ref: peopleMenuWrapperRef,
        "data-testid": `menu-${(0, $5kDtB.NAVIGATION_ITEM_ID).PEOPLE}-wrapper`
    }, (0, $eI5EY.fg)('jwm_tailored_onboarding_invite_team_fix_gate') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, (0, $hFK9U.isUserEnrolledInTailoredOnboardingExperiment)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ZFO4.InviteTeamNudgeAsync), null), renderPeopleMenu()) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hb3Di.ConditionalNudgeWrapper), {
        conditionsToApplyWrapper: (0, $hFK9U.isUserEnrolledInTailoredOnboardingExperiment)(),
        Wrapper: (0, $8ZFO4.InviteTeamNudgeAsyncOld)
    }, renderPeopleMenu())), inviteBusinessTeamsModalData.isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3q7Yq.ModalEntryPointContainer), {
        entryPointReferenceSubject: entryPoint.entryPointReferenceSubject,
        id: "invite-business-teams-modal",
        packageName: "jira-business.invite-business-teams",
        teamName: "a4t-werewolves",
        runtimeProps: {
            userCounts: inviteBusinessTeamsModalData.userCounts,
            onClose: ()=>{
                setInviteBusinessTeamsModalData({
                    isOpen: false,
                    userCounts: 0
                });
            }
        },
        entryPointActions: entryPoint.entryPointActions
    }));
};
const $366c58be1cf242b2$var$PeopleWithAuth = ()=>{
    const isAnonymous = (0, $6yplV.useIsAnonymous)();
    const { isVisible: isVisible } = (0, $cTgSO.useOverflowStatus)();
    if (isAnonymous) return null;
    if (!false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "navigation.people-menu.with-nudgetooltip",
        packageName: (0, $5kDtB.PACKAGE_NAME),
        fallback: "unmount",
        teamName: "navigation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3K78m.NavigationPeopleNavItemWrapperNudgeAsync), {
        isInsideMenu: !isVisible
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ZWbT.FullHeightTextColorWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7ZwLV.InvitePeopleModalContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($366c58be1cf242b2$var$PeopleMenuDropdown, null)))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($366c58be1cf242b2$var$PeopleMenuDropdown, null);
};
const $366c58be1cf242b2$export$8d3edc4d62e152ad = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $grCEQ.TopLevelErrorBoundary), {
        id: (0, $7vTKl.MENU_ID).PEOPLE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($366c58be1cf242b2$var$PeopleWithAuth, null));
const $366c58be1cf242b2$export$5d16118c15d58d20 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4t3i1osq _16jlkb7n _shj5kb7n",
            __cmplp.className
        ])
    });
});

});
parcelRegister("1zdJL", function(module, exports) {

$parcel$export(module.exports, "inviteBusinessTeamsModalEntryPoint", () => $11c2946ac665e539$export$f4db71d255c0573);

var $1K77P = parcelRequire("1K77P");

var $7QhYz = parcelRequire("7QhYz");

const $11c2946ac665e539$export$f4db71d255c0573 = (0, $7QhYz.createEntryPoint)({
    root: (0, $1K77P.JSResourceForInteraction)(()=>(parcelRequire("b03ek")).then((module)=>module.InviteBusinessTeamsModal), {
        moduleId: "c8fe5655"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("b03ek", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('hPzOn'),
            load('kZ6X3')
        ]);
        const value = parcelRequire('af3H7');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("hPzOn"),
        load("kZ6X3")
    ]).then(()=>parcelRequire('af3H7'));
}

});


parcelRegister("2NgrR", function(module, exports) {

$parcel$export(module.exports, "useRenotifyInviteesExperimentForJSW", () => $8063cecfdc74c4d5$export$bfe08dacb1da9172);

var $eUqFw = parcelRequire("eUqFw");

var $7ZZxN = parcelRequire("7ZZxN");

var $eEzyV = parcelRequire("eEzyV");

var $guiFP = parcelRequire("guiFP");

var $79xbN = parcelRequire("79xbN");

var $hCxgq = parcelRequire("hCxgq");
var $dYni1 = parcelRequire("dYni1");

var $bNe1g = parcelRequire("bNe1g");

var $6WXNs = parcelRequire("6WXNs");

var $dxcfv = parcelRequire("dxcfv");
var $ab6rA = parcelRequire("ab6rA");
var $dWLk9 = parcelRequire("dWLk9");
var $1R3n5 = parcelRequire("1R3n5");

var $ew2lR = parcelRequire("ew2lR");
const $8063cecfdc74c4d5$export$bfe08dacb1da9172 = ()=>{
    const { data: data } = (0, $bNe1g.useProjectContext)();
    const { software: softwareEdition } = (0, $ab6rA.useAppEditions)();
    const isSiteAdmin = (0, $1R3n5.useIsSiteAdmin)();
    const isSoftwareProject = data?.projectType === (0, $7ZZxN.SOFTWARE_PROJECT);
    const hasFreeSoftwareEdition = softwareEdition === (0, $6WXNs.FREE_EDITION);
    const isWithin30Day = (0, $dYni1.useIsFirstActivationDateWithinLast30Days)();
    const isAfterOneDay = (0, $hCxgq.useIsFirstActivationDateAfterOneDayMemo)();
    const cloudId = (0, $dWLk9.useCloudId)();
    const userId = (0, $dxcfv.useAccountId)();
    const { loading: isResendTraitFetching, error: resendTraitError, data: timeOfLastResendInvitation, fetch: fetchResendTrait } = (0, $eEzyV.useService)((0, $ew2lR.getTimeOfLastResendInvitation));
    const { loading: isDismissTraitFetching, error: dismissTraitError, data: isRenotifyMessageDismissed, fetch: fetchDismissTrait } = (0, $eEzyV.useService)((0, $ew2lR.getIsRenotifyMessageDismissed));
    const isBasicTarget = isSiteAdmin && isSoftwareProject && hasFreeSoftwareEdition && isAfterOneDay && isWithin30Day;
    const isTargeted = isBasicTarget && !isRenotifyMessageDismissed && timeOfLastResendInvitation !== undefined && (0, $ew2lR.hasAtLeast24HoursElapsed)(timeOfLastResendInvitation);
    (0, $eUqFw.useEffect)(()=>{
        if (!isBasicTarget) return;
        fetchResendTrait(cloudId);
        if (userId) fetchDismissTrait({
            cloudId: cloudId,
            userId: userId
        });
    }, [
        isBasicTarget,
        userId,
        cloudId,
        fetchResendTrait,
        fetchDismissTrait
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (resendTraitError) (0, $guiFP.default)({
            error: resendTraitError,
            meta: {
                id: 'getTimeOfLastResendInvitation',
                packageName: 'jiraExperiments'
            }
        });
        if (dismissTraitError) (0, $guiFP.default)({
            error: dismissTraitError,
            meta: {
                id: 'getIsRenotifyMessageDismissed',
                packageName: 'jiraExperiments'
            }
        });
    }, [
        resendTraitError,
        dismissTraitError
    ]);
    return {
        isLoading: isResendTraitFetching || isDismissTraitFetching,
        isJswTargeted: isTargeted,
        onFetchedPendingUsers: ()=>(0, $79xbN.expValEquals)('jsw_remind_admins_about_invited_users', 'isEnabled', true)
    };
};

});
parcelRegister("hCxgq", function(module, exports) {

$parcel$export(module.exports, "useIsFirstActivationDateAfterOneDayMemo", () => $077593bd008899c1$export$f96ca5090cd1f561);

var $eUqFw = parcelRequire("eUqFw");

var $21Sgb = parcelRequire("21Sgb");
const $077593bd008899c1$var$dayInMs = 86400000;
const $077593bd008899c1$export$f96ca5090cd1f561 = ()=>{
    const firstActivationDate = (0, $21Sgb.useFirstActivationDateMs)();
    const isAfterOneDay = (0, $eUqFw.useMemo)(()=>{
        if (!firstActivationDate) return false;
        return (Date.now() - firstActivationDate) / $077593bd008899c1$var$dayInMs >= 1;
    }, [
        firstActivationDate
    ]);
    return isAfterOneDay;
};

});

parcelRegister("dYni1", function(module, exports) {

$parcel$export(module.exports, "useIsFirstActivationDateWithinLast30Days", () => $a92dd8ceb8d6b884$export$f561835faf21b733);

var $21Sgb = parcelRequire("21Sgb");

var $hRWVt = parcelRequire("hRWVt");
const $a92dd8ceb8d6b884$export$f561835faf21b733 = ()=>{
    const firstActivationDate = (0, $21Sgb.useFirstActivationDateMs)();
    return (0, $hRWVt.isWithinLast30Days)(firstActivationDate);
};

});

parcelRegister("ew2lR", function(module, exports) {

$parcel$export(module.exports, "getIsRenotifyMessageDismissed", () => $427f8dc1b79db4f0$export$455a31b22f63aa7a);
$parcel$export(module.exports, "getTimeOfLastResendInvitation", () => $427f8dc1b79db4f0$export$68a550f6a47a1e52);
$parcel$export(module.exports, "hasAtLeast24HoursElapsed", () => $427f8dc1b79db4f0$export$79c4147d0525f43);

var $ccm3Y = parcelRequire("ccm3Y");
var $jRj3P = parcelRequire("jRj3P");
const $427f8dc1b79db4f0$var$IS_RENOTIFY_MESSAGE_DISMISSED = 'is_renotify_message_dismissed';
const $427f8dc1b79db4f0$var$JSW_RENOTIFY_DISMISS_TRAIT = 'jira-software_ui_button_clicked_dismissbutton_peoplemenu_first_time';
const $427f8dc1b79db4f0$export$455a31b22f63aa7a = async ({ cloudId: cloudId, userId: userId })=>{
    const localStorageValue = window.localStorage?.getItem($427f8dc1b79db4f0$var$IS_RENOTIFY_MESSAGE_DISMISSED);
    if (localStorageValue === 'true' || localStorageValue === 'false') return localStorageValue === 'true';
    const response = await (0, $jRj3P.memoizedFetchSiteUserPersonalization)({
        cloudId: cloudId,
        userId: userId
    });
    const targetTraitValue = response.find((traits)=>traits.name === $427f8dc1b79db4f0$var$JSW_RENOTIFY_DISMISS_TRAIT)?.value;
    if (targetTraitValue) localStorage.setItem($427f8dc1b79db4f0$var$IS_RENOTIFY_MESSAGE_DISMISSED, 'true');
    return !!targetTraitValue;
};
const $427f8dc1b79db4f0$var$TIME_OF_LAST_RESEND_INVITATION = 'time_of_last_resend_invitation';
const $427f8dc1b79db4f0$var$JSW_SEND_REMIND_LAST_TRAIT = 'jira-software_ui_button_clicked_sendreminderbutton_navigationnextscreen_last_time';
const $427f8dc1b79db4f0$export$68a550f6a47a1e52 = async (cloudId)=>{
    const localStorageValue = window.localStorage?.getItem($427f8dc1b79db4f0$var$TIME_OF_LAST_RESEND_INVITATION);
    if (typeof localStorageValue === 'string') {
        const parsedLocalStorageValue = parseInt(localStorageValue, 10);
        if (!Number.isNaN(parsedLocalStorageValue)) return parsedLocalStorageValue;
    }
    const response = await (0, $ccm3Y.memoizedFetchSitePersonalization)({
        cloudId: cloudId
    });
    const targetTraitValue = response.find((traits)=>traits.name === $427f8dc1b79db4f0$var$JSW_SEND_REMIND_LAST_TRAIT)?.value;
    if (typeof targetTraitValue === 'string') {
        const timeOfLastResend = new Date(targetTraitValue).getTime();
        localStorage.setItem($427f8dc1b79db4f0$var$TIME_OF_LAST_RESEND_INVITATION, `${timeOfLastResend}`);
        return timeOfLastResend;
    }
    return 0;
};
const $427f8dc1b79db4f0$export$79c4147d0525f43 = (timeOfLastResendInvitation)=>{
    const TWENTY_FOUR_HOURS_IN_MS = 86400000;
    return Date.now() - timeOfLastResendInvitation >= TWENTY_FOUR_HOURS_IN_MS;
};

});
parcelRegister("ccm3Y", function(module, exports) {

$parcel$export(module.exports, "memoizedFetchSitePersonalization", () => $23253fa24cdf456f$export$671fb03be30194c3);
$parcel$export(module.exports, "useSitePersonalization", () => $23253fa24cdf456f$export$58982988039b926f);

var $5iWql = parcelRequire("5iWql");

var $eEzyV = parcelRequire("eEzyV");

var $2OdyW = parcelRequire("2OdyW");
const $23253fa24cdf456f$var$getPersonalizationSiteTraitsUrl = (cloudId)=>`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}`;
const $23253fa24cdf456f$export$ddf4964d2a406b6a = async ({ cloudId: cloudId })=>{
    if (!cloudId) throw new Error('empty cloudId');
    const { attributes: attributes } = await (0, $2OdyW.default)($23253fa24cdf456f$var$getPersonalizationSiteTraitsUrl(cloudId), {
        method: 'GET',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'x-atlassian-mau-ignore': 'true'
        }
    });
    return attributes;
};
const $23253fa24cdf456f$export$671fb03be30194c3 = (0, $5iWql.default)($23253fa24cdf456f$export$ddf4964d2a406b6a, ([{ cloudId: newCloudId }], [{ cloudId: lastCloudId }])=>newCloudId === lastCloudId);
const $23253fa24cdf456f$export$58982988039b926f = ()=>(0, $eEzyV.useService)($23253fa24cdf456f$export$671fb03be30194c3);

});



parcelRegister("3Y2Y8", function(module, exports) {

$parcel$export(module.exports, "default", () => $23cb4ade2efc0679$export$2e2bcd8739ae039);

var $kQ0RL = parcelRequire("kQ0RL");
var $23cb4ade2efc0679$export$2e2bcd8739ae039 = (0, $kQ0RL.ErrorFlag);

});
parcelRegister("kQ0RL", function(module, exports) {

$parcel$export(module.exports, "CommonFlag", () => $2ffdc518941fd08c$export$13d73238a031436b);
$parcel$export(module.exports, "ErrorFlag", () => $2ffdc518941fd08c$export$518ba8e0e60f145f);
$parcel$export(module.exports, "ErrorAutoDismissFlag", () => $2ffdc518941fd08c$export$3f75672bb90a4431);
$parcel$export(module.exports, "InfoFlag", () => $2ffdc518941fd08c$export$6a55b52e74c1e48e);
$parcel$export(module.exports, "SuccessAutoDismissFlag", () => $2ffdc518941fd08c$export$74a3c0748aa31355);
$parcel$export(module.exports, "SuccessFlag", () => $2ffdc518941fd08c$export$93bd4963a1d00fd5);
$parcel$export(module.exports, "WarningFlag", () => $2ffdc518941fd08c$export$23695d8281998f27);
$parcel$export(module.exports, "FlagGroup", () => $2ffdc518941fd08c$export$a2c3479950310d7d);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $5L0Jp = parcelRequire("5L0Jp");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2ffdc518941fd08c$var$ForPaintCommonFlag = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("aiVXY")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/common-flag-v2/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2ffdc518941fd08c$var$AfterPaintCommonFlag = (0, $7rh0R.lazyAfterPaint)(// eslint-disable-next-line jira/import/webpack-magic-comment-entries
()=>(parcelRequire("aiVXY")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/common-flag-v2/index.tsx"
});
const $2ffdc518941fd08c$var$CommonFlagImpl = (props)=>__SPA__ ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$AfterPaintCommonFlag, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$ForPaintCommonFlag, props);

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2ffdc518941fd08c$var$ForPaintFlagGroup = (0, $7rh0R.lazyForPaint)(// eslint-disable-next-line jira/import/webpack-magic-comment-entries
()=>(parcelRequire("Tabui")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/group-flag-v2/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2ffdc518941fd08c$var$AfterPaintFlagGroup = (0, $7rh0R.lazyAfterPaint)(// eslint-disable-next-line jira/import/webpack-magic-comment-entries
()=>(parcelRequire("Tabui")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/group-flag-v2/index.tsx"
});
const $2ffdc518941fd08c$var$FlagGroupImpl = (props)=>__SPA__ ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$AfterPaintFlagGroup, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$ForPaintFlagGroup, props);
const $2ffdc518941fd08c$export$13d73238a031436b = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, props));
const $2ffdc518941fd08c$export$518ba8e0e60f145f = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "error",
        ...props
    }));
const $2ffdc518941fd08c$export$3f75672bb90a4431 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "error",
        isAutoDismiss: true,
        ...props
    }));
const $2ffdc518941fd08c$export$6a55b52e74c1e48e = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "info",
        ...props
    }));
const $2ffdc518941fd08c$export$74a3c0748aa31355 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "success",
        isAutoDismiss: true,
        ...props
    }));
const $2ffdc518941fd08c$export$93bd4963a1d00fd5 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "success",
        ...props
    }));
const $2ffdc518941fd08c$export$23695d8281998f27 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "warning",
        ...props
    }));
const $2ffdc518941fd08c$export$a2c3479950310d7d = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$FlagGroupImpl, props));

});
parcelRegister("aiVXY", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('cCYJs')
        ]);
        const value = parcelRequire('kbpOk');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("cCYJs")
    ]).then(()=>parcelRequire('kbpOk'));
}

});

parcelRegister("Tabui", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('hkLGi');
        const value = parcelRequire('jkRT2');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("hkLGi").then(()=>parcelRequire('jkRT2'));
}

});



parcelRegister("Gz4Lz", function(module, exports) {

$parcel$export(module.exports, "default", () => $1273ecbdbcfe24cd$export$2e2bcd8739ae039);

var $kQ0RL = parcelRequire("kQ0RL");
var $1273ecbdbcfe24cd$export$2e2bcd8739ae039 = (0, $kQ0RL.SuccessFlag);

});

parcelRegister("82rJa", function(module, exports) {

$parcel$export(module.exports, "default", () => $9c8bd85b08cb5610$export$2e2bcd8739ae039);

var $kQ0RL = parcelRequire("kQ0RL");
var $9c8bd85b08cb5610$export$2e2bcd8739ae039 = (0, $kQ0RL.WarningFlag);

});

parcelRegister("iFLJg", function(module, exports) {

$parcel$export(module.exports, "stripUrlToIssueKey", () => $068703c2c99fc355$export$1f3c6284caef177b);
$parcel$export(module.exports, "useInvitePeopleFlags", () => $068703c2c99fc355$export$ab5fb7206b83c9ad);
$parcel$export(module.exports, "projectTypeToSubProduct", () => $068703c2c99fc355$export$3500077858760067);

var $eUqFw = parcelRequire("eUqFw");

var $k8Qyf = parcelRequire("k8Qyf");

var $3Y2Y8 = parcelRequire("3Y2Y8");

var $90ffs = parcelRequire("90ffs");

var $Gz4Lz = parcelRequire("Gz4Lz");

var $82rJa = parcelRequire("82rJa");
const $068703c2c99fc355$var$ISSUE_KEY_REGEXP = /(([A-Z][A-Z0-9]+)-([0-9]+))($|\?.*)/;
const $068703c2c99fc355$export$1f3c6284caef177b = (candidateUrl)=>{
    const match = candidateUrl.match($068703c2c99fc355$var$ISSUE_KEY_REGEXP);
    return match && match[1];
};
const $068703c2c99fc355$export$ab5fb7206b83c9ad = ()=>{
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    const addFlag = (0, $eUqFw.useCallback)(// @ts-expect-error - TS7031 - Binding element 'appearance' implicitly has an 'any' type.
    ({ appearance: appearance, ...flagProps })=>{
        let FlagComponent = (0, $90ffs.default);
        // eslint-disable-next-line default-case
        switch(appearance){
            case 'success':
            case 'normal':
                FlagComponent = (0, $Gz4Lz.default);
                break;
            case 'warning':
                FlagComponent = (0, $82rJa.default);
                break;
            case 'error':
                FlagComponent = (0, $3Y2Y8.default);
                break;
        }
        // @ts-expect-error Type error after Flag props have been fixed globally, to be fixed by owning team
        showFlag((serviceProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(FlagComponent, {
                ...flagProps,
                ...serviceProps
            }));
    }, [
        showFlag
    ]);
    return {
        addFlag: addFlag
    };
};
const $068703c2c99fc355$export$3500077858760067 = (projectType)=>{
    switch(projectType){
        case 'jira_software':
            return 'software';
        case 'jira_service_management':
            return 'servicedesk';
        case 'jira_work_management':
            return 'core';
        case 'jira_product_discovery':
            return 'product-discovery';
        default:
            return undefined;
    }
};

});
parcelRegister("90ffs", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b69c2b71403c7d4$export$2e2bcd8739ae039);

var $kQ0RL = parcelRequire("kQ0RL");
var $8b69c2b71403c7d4$export$2e2bcd8739ae039 = (0, $kQ0RL.InfoFlag);

});


// Session storage constants used between going through initial onboarding screens
// and landing in JIRA
// Note this key used to be 'should-show-scrum-modal' but was changed to prevent a bug where experienced users
// Could see the modal if they were previously enrolled into ISO
const $8379f5d78bf6fb5a$export$67abe0a3b8dfe03f = 'should-show-scrum-modal-v2';
const $8379f5d78bf6fb5a$export$4e1360a3e7785935 = 'should-show-kanban-modal';
const $8379f5d78bf6fb5a$export$e3884212029f7bef = 'should-show-welcome-modal';
const $8379f5d78bf6fb5a$export$928ffae10e4c0006 = 'template-key-to-show-onboarding-modal';
const $8379f5d78bf6fb5a$export$8a00ecf6498ee2fe = 'onboarding-selected-project-template-type';
const $8379f5d78bf6fb5a$export$69fe8832c4f79a32 = 'onboarding_started_timestamp';
const $8379f5d78bf6fb5a$export$a8d62e500b59f31e = 'boardCreateColumnButtonNudge';
const $8379f5d78bf6fb5a$export$92c7f0eacc8d8d98 = 'assigneeFilterAddPeopleButtonNudge';
const $8379f5d78bf6fb5a$export$dd63d0099d95ba4f = 'navigationAppsNavItemNudge';
const $8379f5d78bf6fb5a$export$aba87e019f5ccb8d = 'navigationCreateIssueButtonNudge';
const $8379f5d78bf6fb5a$export$46d9a3d441dfd22b = 'navigationPlansNavItemNudge';
const $8379f5d78bf6fb5a$export$e20072f7d0c5357f = 'roadmapCreateEpicButtonNudge';
const $8379f5d78bf6fb5a$export$1e39959907a7f359 = 'roadmapCreateEpicChildIssueButtonNudge';
const $8379f5d78bf6fb5a$export$b74a8fdb2c75b869 = 'navigationPeopleNavItemNudge';
const $8379f5d78bf6fb5a$export$b1a6ab17737f33e = 'backlogAccordionNudge';
const $8379f5d78bf6fb5a$export$3366ddefe77d5112 = 'boardCreateColumnNudge';
const $8379f5d78bf6fb5a$export$9d9e95a66a2c6abe = 'addItemsCalendarNudge';
const $8379f5d78bf6fb5a$export$69aca8ebee0d34c8 = 'trelloCrossflowAddItemsCalendarNudge';
const $8379f5d78bf6fb5a$export$dd4b359b5a58cdc0 = 'trelloCrossflowTimelineTabNudge';
const $8379f5d78bf6fb5a$export$7aa8bceae32c7862 = 'navigationAppsProfileItemNudge';
const $8379f5d78bf6fb5a$export$c6df9a2c7447e12d = 'getStartedListNudge';
const $8379f5d78bf6fb5a$export$468488291ccd988 = 'timelineAddItemNudge';
const $8379f5d78bf6fb5a$export$7a33548109ac931d = 'createFormNudge';
const $8379f5d78bf6fb5a$export$b65ba9ea0c0ced43 = 'jsw-onboarding-checklist.open';
const $8379f5d78bf6fb5a$export$594d3436316492be = 'summaryViewNudge';
const $8379f5d78bf6fb5a$export$77bc79debbf5c069 = 'inviteTeamNudge';
const $8379f5d78bf6fb5a$export$73278890f736ee6f = 'manageProjectsNudge';

parcelRegister("3K78m", function(module, exports) {

$parcel$export(module.exports, "NavigationPeopleNavItemWrapperNudgeAsync", () => $e174e45e15d1fc02$export$57ea67608b7cb448);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");


var $ewdMq = parcelRequire("ewdMq");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $e174e45e15d1fc02$var$NavigationPeopleNavItemLazy = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("b3xsW")).then((exportedModule)=>exportedModule.NavigationPeopleNavItemWrapperNudge), {
    ssr: false,
    moduleId: "./src/packages/software/onboarding-nudges/src/ui/navigation-people/index.tsx"
});
const $e174e45e15d1fc02$export$57ea67608b7cb448 = ({ children: children, isInsideMenu: isInsideMenu })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ewdMq.OnboardingNudgeErrorBoundary), {
        id: (0, $8379f5d78bf6fb5a$export$b74a8fdb2c75b869),
        fallback: children,
        attributes: {
            nudgeId: (0, $8379f5d78bf6fb5a$export$b74a8fdb2c75b869)
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "navigation-people-nav-item-lazy",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e174e45e15d1fc02$var$NavigationPeopleNavItemLazy, {
        nudgeId: (0, $8379f5d78bf6fb5a$export$b74a8fdb2c75b869),
        isInsideMenu: isInsideMenu
    }, children)));

});
parcelRegister("b3xsW", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('2IDHF');
        const value = parcelRequire('b4FpA');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("2IDHF").then(()=>parcelRequire('b4FpA'));
}

});


parcelRegister("8ZFO4", function(module, exports) {

$parcel$export(module.exports, "InviteTeamNudgeAsyncOld", () => $77203fa7077d439b$export$ba455848f7692ecf);
$parcel$export(module.exports, "InviteTeamNudgeAsync", () => $77203fa7077d439b$export$a4b4061b22dbc897);

var $eUqFw = parcelRequire("eUqFw");

var $6j4bv = parcelRequire("6j4bv");

var $1HzcR = parcelRequire("1HzcR");


var $5cLMB = parcelRequire("5cLMB");


var $105cx = parcelRequire("105cx");

var $fSS7i = parcelRequire("fSS7i");
const $77203fa7077d439b$var$runtimeProps = {};
const $77203fa7077d439b$var$entryPointParams = {};
const $77203fa7077d439b$export$ba455848f7692ecf = ({ children: children })=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $6j4bv.useEntryPoint)((0, $fSS7i.inviteTeamNudgeEntryPoint), $77203fa7077d439b$var$entryPointParams);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $eUqFw.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    const { ref: inviteTeamNudgeRef } = (0, $105cx.useRegisterNudgeTarget)((0, $8379f5d78bf6fb5a$export$77bc79debbf5c069), true);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        ref: inviteTeamNudgeRef
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
        id: (0, $99a775c02d636a41$export$3bc551fe07069f89),
        packageName: "jiraInviteTeamOnboarding",
        entryPointReferenceSubject: entryPointReferenceSubject,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null),
        runtimeProps: $77203fa7077d439b$var$runtimeProps
    }));
};
const $77203fa7077d439b$export$a4b4061b22dbc897 = ()=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $6j4bv.useEntryPoint)((0, $fSS7i.inviteTeamNudgeEntryPoint), $77203fa7077d439b$var$entryPointParams);
    const [nudgeStep] = (0, $5cLMB.useNudgeStep)();
    const [hasNudgeActive] = (0, $5cLMB.useHasNudgeActive)();
    const firstLoadRef = (0, $eUqFw.useRef)(true);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $eUqFw.useEffect)(()=>{
        if (firstLoadRef.current && hasNudgeActive && nudgeStep === (0, $8379f5d78bf6fb5a$export$77bc79debbf5c069)) {
            entryPointActions.load();
            firstLoadRef.current = false;
        }
    }, [
        entryPointActions,
        hasNudgeActive,
        nudgeStep
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
        id: (0, $99a775c02d636a41$export$3bc551fe07069f89),
        packageName: "jiraInviteTeamOnboarding",
        entryPointReferenceSubject: entryPointReferenceSubject,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null),
        runtimeProps: $77203fa7077d439b$var$runtimeProps
    });
};

});
const $99a775c02d636a41$export$64d75060ee6ba425 = 'backlogCreateIssueNudge';
const $99a775c02d636a41$export$e0197e09cccd4e50 = 'backlogCreateSprintNudge';
const $99a775c02d636a41$export$6770a2081a63fc15 = 'backlogStartSprintNudge';
const $99a775c02d636a41$export$63b61f654ce3da3d = 'backlogCompleteSprintNudge';
const $99a775c02d636a41$export$1c7a80b00ad9619 = 'backlogInsightsNudge';
const $99a775c02d636a41$export$b8b9d90f9e5bd72b = 'jiraSoftwareOnboardingNudges';
const $99a775c02d636a41$export$65fb0c4e534f03fc = 'asyncScrumTourNudge';
const $99a775c02d636a41$export$f2fe211acb4aa81a = 'asyncKanbanTourNudge';
const $99a775c02d636a41$export$fb9c6e63a7490968 = 'asyncJWMCalendarTourNudge';
const $99a775c02d636a41$export$df53a339af97f102 = 'asyncJWMCalendarAndTimelineTourNudge';
const $99a775c02d636a41$export$573d4bf1da6d2bc6 = 'asyncJWMBoardTourNudge';
const $99a775c02d636a41$export$501e36925fa10eef = 'asyncJWMListTourNudge';
const $99a775c02d636a41$export$2f06a16c987cc1a2 = 'asyncJWMTimelineTourNudge';
const $99a775c02d636a41$export$226bdcb034c75951 = 'asyncJWMFormTourNudge';
const $99a775c02d636a41$export$b72fce9f4cf11b5c = 'asyncJWMTrelloKeyDifferencesTourNudge';
const $99a775c02d636a41$export$306510c7b1760652 = 'asyncJWMSummaryAndReportsTabNudge';
const $99a775c02d636a41$export$cf1943561be3a3c2 = 'asyncJWMSummaryViewNudge';
const $99a775c02d636a41$export$4d6567e7ee0281bf = 'asyncManageProjectsNudge';
const $99a775c02d636a41$export$f8bf435a6066832c = 'button clicked';
const $99a775c02d636a41$export$3bc551fe07069f89 = 'asyncJWMInviteTeamNudge';
const $99a775c02d636a41$export$4db327e1949c2108 = 'boardInProgressColumnNudge';
const $99a775c02d636a41$export$a402f2c11da96cd7 = 'boardCreateIssueNudge';
const $99a775c02d636a41$export$1e174cd1e0212f3a = 'navigateCalendarNudge';
const $99a775c02d636a41$export$6ffa29e74c0304c4 = 'tailorBoardColumnsNudge';
const $99a775c02d636a41$export$a1398a6ef9526001 = 'inlineEditListNudge';
const $99a775c02d636a41$export$5908fa8acd2c0739 = 'filterListNudge';
const $99a775c02d636a41$export$50192b0fdc9bdacf = 'moreDropdownListNudge';
const $99a775c02d636a41$export$e34e81ed4f255f6e = 'timelineAddDateNudge';
const $99a775c02d636a41$export$aac6e5779d47ef37 = 'timelineAddChildItemNudge';
const $99a775c02d636a41$export$69aca8ebee0d34c8 = 'trelloCrossflowAddItemsCalendarNudge';
const $99a775c02d636a41$export$dd4b359b5a58cdc0 = 'trelloCrossflowTimelineTabNudge';
const $99a775c02d636a41$export$1e0e647cc08bb4d8 = 'trelloKeyDifferencesIssueNudge';
const $99a775c02d636a41$export$762576896c225bd6 = 'trelloKeyDifferencesSummaryNudge';
const $99a775c02d636a41$export$5a96f813312dc7fa = 'trelloKeyDifferencesBoardNudge';
const $99a775c02d636a41$export$ae8eeb04e0b1e9af = 'availableFieldsFormNudge';
const $99a775c02d636a41$export$a54d77300f1dddea = 'changeIssueTypeFormNudge';
const $99a775c02d636a41$export$6afdc7e5f6d2e915 = 'previewSaveFormNudge';
const $99a775c02d636a41$export$eb0b199de90a7ec2 = 'backgroundColorNudge';
const $99a775c02d636a41$export$e9e47a7ad42e71f5 = 'feedbackNudge';
const $99a775c02d636a41$export$791f56b3d78403cc = 'calendarReleasesNudge';
const $99a775c02d636a41$export$a1be34032ee24f78 = 'shareProjectNudge';
const $99a775c02d636a41$export$29fe6611cc093756 = 'summaryTabNudge';
const $99a775c02d636a41$export$f107c06c0830f09d = 'reportsTabNudge';

parcelRegister("fSS7i", function(module, exports) {

$parcel$export(module.exports, "inviteTeamNudgeEntryPoint", () => $7ee3503d9bc55fd6$export$ff76bc343b4103b1);

var $1K77P = parcelRequire("1K77P");

var $7QhYz = parcelRequire("7QhYz");

const $7ee3503d9bc55fd6$export$ff76bc343b4103b1 = (0, $7QhYz.createEntryPoint)({
    root: (0, $1K77P.JSResourceForInteraction)(()=>(parcelRequire("t13LP")), {
        moduleId: "4ca4d8af"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("t13LP", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('8nQSH');
        const value = parcelRequire('c1S71');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("8nQSH").then(()=>parcelRequire('c1S71'));
}

});



parcelRegister("eXtUa", function(module, exports) {

$parcel$export(module.exports, "useBrowseUsersGroupsPermissions", () => $ac7fdc7a19db38ab$export$c12f7f185a3a245f);

var $eUqFw = parcelRequire("eUqFw");

var $lRmyA = parcelRequire("lRmyA");

var $h3mHU = parcelRequire("h3mHU");
const $ac7fdc7a19db38ab$var$deferredPromise = ()=>{
    const deferred = {
        resolve: undefined,
        reject: undefined
    };
    const promise = new Promise(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (resolve, reject)=>{
        // @ts-expect-error - TS2322 - Type '(result: boolean) => void' is not assignable to type 'undefined'.
        deferred.resolve = (result)=>{
            resolve(result);
        };
        // @ts-expect-error - TS2322 - Type '(error?: any) => void' is not assignable to type 'undefined'.
        deferred.reject = reject;
    });
    return {
        promise: promise,
        ...deferred
    };
};
const $ac7fdc7a19db38ab$export$c12f7f185a3a245f = ()=>{
    const [{ isReady: isReady }] = (0, $h3mHU.useSpaStatePageReady)();
    const [{ promise: promise, resolve: resolve, reject: reject }] = (0, $eUqFw.useState)($ac7fdc7a19db38ab$var$deferredPromise());
    (0, $eUqFw.useEffect)(()=>{
        if (isReady) {
            const requestUrl = '/rest/internal/latest/userPermission/browseUsersGroups';
            (0, $lRmyA.performGetRequest)(requestUrl).then(resolve).catch(reject);
        }
    }, [
        isReady,
        reject,
        resolve
    ]);
    return (0, $eUqFw.useCallback)(()=>promise, [
        promise
    ]);
};

});

parcelRegister("5Jczu", function(module, exports) {

$parcel$export(module.exports, "useTPAExperiment", () => $420f50728b605a4b$export$f72f7a0d0e0f9566);

var $eUqFw = parcelRequire("eUqFw");

var $hzKLE = parcelRequire("hzKLE");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");
const $420f50728b605a4b$export$f72f7a0d0e0f9566 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { value: value, explanation: explanation } = (0, $hzKLE.getFeatureFlagClient)().getFlagEvaluation('confluence.frontend.growth.team-product-access', {
        default: false
    });
    const reason = explanation?.kind ?? '';
    return (0, $eUqFw.useMemo)(()=>({
            enabled: value,
            reason: reason,
            fireFeatureExposed: ()=>{
                const event = createAnalyticsEvent({});
                const cohort = value ? 'variation' : 'not-enrolled';
                event.context.push({
                    source: 'team-create-dialog',
                    tags: [
                        'people-teams'
                    ]
                });
                (0, $jMP2a.fireTrackAnalytics)(event, 'feature exposed', {
                    flagKey: 'confluence.frontend.growth.team-product-access',
                    cohort: !value && reason === 'RULE_MATCH' ? 'control' : cohort,
                    value: value,
                    reason: reason
                });
            },
            growthHoldoutCohort: 'variation'
        }), [
        createAnalyticsEvent,
        reason,
        value
    ]);
};

});

parcelRegister("d5ydC", function(module, exports) {

$parcel$export(module.exports, "getInvitedJswUsers", () => $0e33ff918f2f84dc$export$4b81d3bf9fd2c126);

var $guiFP = parcelRequire("guiFP");


var $huI7r = parcelRequire("huI7r");

const $0e33ff918f2f84dc$export$4b81d3bf9fd2c126 = (inviteUsersResponse)=>{
    try {
        if (inviteUsersResponse.status === 'fulfilled' && inviteUsersResponse.value.responseStatus === 'success' && 'invited' in inviteUsersResponse.value.response) {
            const invitedUsers = inviteUsersResponse.value.response.invited;
            return invitedUsers.filter((invitedUser)=>{
                const productInvites = Object.keys(invitedUser.results);
                return productInvites.some((invite)=>{
                    const ari = (0, $huI7r.toAri)(invite);
                    return ari ? (0, $huI7r.getAriConfig)(ari).resourceOwner === (0, $2edfd53057852e41$export$1346c9aa3cbb477d) && invitedUser.results[invite] === 'INVITED' : false;
                });
            });
        }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        (0, $guiFP.default)({
            error: e,
            meta: {
                id: 'getInvitedJswUsers',
                packageName: (0, $556d3824e23bb4a1$export$b8b9d90f9e5bd72b),
                // eslint-disable-next-line jira/js/team-name-enforcer-for-error-analytics
                teamName: 'Flywheel-Tako'
            }
        });
    }
    return [];
};

});
const $556d3824e23bb4a1$export$b8b9d90f9e5bd72b = 'jiraGrowthUtils';

const $2edfd53057852e41$export$c8c1c8c3f8ddba61 = 'jira-servicedesk';
const $2edfd53057852e41$export$e9c56aa3b027d98f = 'jira-customer-service';
const $2edfd53057852e41$export$1346c9aa3cbb477d = 'jira-software';
const $2edfd53057852e41$export$202f50ee62667e32 = 'jira-product-discovery';
const $2edfd53057852e41$export$db515c8cec1e6f79 = 'jira-core';
const $2edfd53057852e41$export$c811f21c9ad05dc2 = 'confluence';
const $2edfd53057852e41$export$961148c98d198270 = 'opsgenie';




//# sourceMappingURL=async-people-menu.de829270.js.map
